/** @format */

import React, { Component, PureComponent } from 'react';
import Paginations from '../../components/Pagination/PaginationExt';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from 'assets/jss/adescom/adescomStyle';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import { Directions } from 'mdi-material-ui';
import InputAdornment from '@material-ui/core/InputAdornment';
import i18n from '../../core/i18n';
import { componentDebug } from '../../core/debug';
import COLORS from '../../assets/themes/OPL/colors';
import oplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';
import cx from 'classnames';

class PagerRange extends Component {
    constructor(props, context) {
        super(props, context);
        const pagination = this.getPaginationFromViews(this.props.views);

        const current = pagination['currentPage'];
        let page = '';
        let iri = '';
        if (current) {
            page = current.page;
            iri = pagination['iri'];
        }
        const [pages, currentPage] = this.createPages();
        const goToPage = (
            <TextField
                onChange={this.goToPage}
                onKeyDown={this.handleKeyDown}
                variant={'filled'}
                classes={props.classes.paginatorTextField}
                value={page}
                inputProps={{
                    className: props.classes.paginatorInputStyle,
                }}
                InputProps={{
                    className: props.classes.paginatorLabelStyle,
                }}
            />
        );
        this.state = {
            currentPage: page,
            goToPageButton: goToPage,
            callIri: iri,
            pages: pages,
        };
    }

    buttonHit = (url, fromTextField) => {
        const { callback, classes } = this.props;
        const pagination = this.getPaginationFromViews(this.props.views);
        const current = pagination['currentPage'];

        if (callback) {
            callback(url);
        } else {
            componentDebug('No callback function');
        }
    };

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const pagination = this.getPaginationFromViews(this.props.views);
        const nextPagination = this.getPaginationFromViews(nextProps.views);
        const current = pagination['currentPage'];
        const nextCurrent = nextPagination['currentPage'];
        if (
            (current.page && nextCurrent.page && (current.page > nextCurrent.page || current.page < nextCurrent.page)) ||
            this.state.currentPage !== nextState.currentPage ||
            nextProps.views['hydra:totalItems'] !== this.props.views['hydra:totalItems']
        ) {
            let [pages, currentPage] = this.createPages(nextProps.views);
            if (this.state.currentPage !== nextState.currentPage) {
                currentPage = nextState.currentPage;
            }
            const goToPage = (
                <TextField
                    onChange={this.goToPage}
                    onKeyDown={this.handleKeyDown}
                    variant={'filled'}
                    classes={this.props.classes.paginatorTextField}
                    value={currentPage}
                    inputProps={{
                        className: this.props.classes.paginatorInputStyle,
                    }}
                    InputProps={{
                        className: this.props.classes.paginatorLabelStyle,
                    }}
                />
            );
            this.setState(
                (prevState) => ({
                    ...prevState,
                    pages: pages,
                    currentPage: currentPage,
                    goToPageButton: goToPage,
                }),
                () => {}
            );
        }

        return true;
    }

    goToPage = (event) => {
        const value = event.target.value;
        const pagination = this.getPaginationFromViews(this.props.views);
        const totalPage = pagination['totalPage'];
        const rgxAsStr = `^[0-9]+$`;
        const rgx = new RegExp(rgxAsStr);

        if (!value.match(rgx) && value !== '') {
            return;
        }
        if ((parseInt(value) > totalPage || parseInt(value) < 1) && value !== '') {
            return;
        }
        this.setState((prevState) => ({
            ...prevState,
            currentPage: value,
        }));
    };

    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.handleButtonPress();
        }
    };

    handleButtonPress = () => {
        this.buttonHit(this.getCurrentIri(), true);
    };

    getPage = (page, active, disabled) => {
        if (active === true) {
            return { text: page.page, url: page.iri, active: true };
        }
        if (disabled === true) {
            return { text: page.page, url: page.iri, disabled: true };
        }
        return { text: page.page, url: page.iri, onClick: this.buttonHit };
    };

    getNumberFromUri = (uri) => {
        const reg = /[?&]{1,}page=(\d+)/gi;
        const nr = reg.exec(uri);
        if (nr && nr[1]) {
            return nr[1];
        }
        return null;
    };

    getPaginationFromViews = (views) => {
        if (views && views['@pagination'] && (this.props.pagination === undefined || this.props.pagination === null)) {
            return views['@pagination'];
        }
        return this.props.pagination;
    };

    getCurrentIri = () => {
        const pagination = this.getPaginationFromViews(this.props.views);
        return pagination['iri'] + '&page=' + this.state.currentPage;
    };

    createPages = (fromNextProps) => {
        const pagination = this.getPaginationFromViews(fromNextProps ?? this.props.views);

        const toFirst = pagination['toFirst'];
        const toLast = pagination['toLast'];
        const current = pagination['currentPage'];
        const totalPage = pagination['totalPage'];
        const pages = [];
        if (toFirst.length === 0) {
            pages.push(this.getPage({ page: 1 }, false, true));
        } else {
            pages.push(this.getPage(toFirst[toFirst.length - 1]));
        }

        if (toLast.length === 0 && totalPage - current.page === 1) {
            pages.push(this.getPage({ page: totalPage, iri: pagination['iri'] + '&page=' + totalPage }, false, false));
        } else if (toLast.length === 0 && totalPage - current.page === 0) {
            pages.push(this.getPage({ page: totalPage, iri: pagination['iri'] + '&page=' + totalPage }, false, true));
        } else {
            pages.push(this.getPage(toLast[0]));
        }
        return [pages, current.page];
    };

    goToLastPage = () => {
        const pagination = this.getPaginationFromViews(this.props.views);
        const totalPage = pagination['totalPage'];
        this.buttonHit(pagination['iri'] + '&page=' + totalPage);

        const goToPage = (
            <TextField
                onChange={this.goToPage}
                onKeyDown={this.handleKeyDown}
                variant={'filled'}
                classes={this.props.classes.paginatorTextField}
                value={totalPage}
                inputProps={{
                    className: this.props.classes.paginatorInputStyle,
                }}
                InputProps={{
                    className: this.props.classes.paginatorLabelStyle,
                }}
            />
        );
        this.setState((prevState) => ({
            ...prevState,
            currentPage: totalPage,
            goToPageButton: goToPage,
        }));
    };

    render() {
        const { classes, setCurrentPage } = this.props;

        let views = this.props.views;
        const pagination = this.getPaginationFromViews(views);
        let itemsListCount = 0;

        if (views['hydra:view']) {
            views = views['hydra:view'];
            itemsListCount = this.props.views['hydra:member'].length;
        }
        const current = pagination['currentPage'];
        const totalPage = pagination['totalPage'];
        const totalItems = this.props.views['hydra:totalItems'];
        const iri = pagination['iri'];
        const itemPerPage = pagination['itemPerPage'];
        let toPage = itemPerPage * current.page;
        const fromPage = toPage - itemPerPage + 1;
        if (itemsListCount !== itemPerPage) {
            toPage = toPage - (itemPerPage - itemsListCount);
        }

        if (current === null || current === undefined) {
            return null;
        }
        return (
            <Paginations
                goToPage={this.state.goToPageButton}
                paddingTop={true}
                pages={this.state.pages}
                color="info"
                currentPage={this.state.currentPage}
                goToLastPage={this.goToLastPage}
                totalItems={totalItems}
                totalPage={pagination['totalPage']}
                fromPage={fromPage}
                toPage={toPage}
            />
        );
    }
}

PagerRange.propTypes = {
    classes: PropTypes.object.isRequired,
    views: PropTypes.object.isRequired,
    pagination: PropTypes.object,
    callback: PropTypes.func.isRequired,
    setCurrentPage: PropTypes.func,
};

export default withStyles(oplAppStyle)(PagerRange);
